<div class="container mt-4" *ngIf="!loading && report">
  <h2>📊 Detalle del reporte semanal</h2>
  <p class="text-muted">Fecha de generación: {{ report.date }}</p>
  <p><strong>Total de clientes:</strong> {{ report.totalClientes }}</p>

  <div class="text-right mb-3">
    <button class="btn btn-success" (click)="excel()" [disabled]="loading">
      <i class="fas fa-file-excel"></i> Exportar a Excel
    </button>
  </div>

  <table class="table table-striped mt-3">
    <thead>
      <tr>
        <th>Cliente</th>
        <th>Plan</th>
        <th>Fecha corte</th>
        <th>Horas Consumidas</th>
        <th>Horas Plan</th>
        <th>Uso (%)</th>        
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of report.data">
        <td>{{ item.cliente }}</td>
        <td>{{ item.plan }}</td>
        <td>
          {{ item.fechaCorte ? (item.fechaCorte | date:'dd/MM/yyyy') : 'N/A' }}
        </td>
        <td>{{ item.horasConsumidas }}</td>
        <td>{{ item.horasPlan }}</td>
        <td>{{ item.uso }}</td>        
      </tr>
    </tbody>
  </table>
</div>

<div *ngIf="loading" class="text-center mt-5">
  <p>Cargando reporte...</p>
</div>
